import { SubscriptionProcessState } from "../types";
import { fetchBorrowerProject } from "./async/fetchBorrowerProject";
import { fetchSubscriptionProcess } from "./async/fetchSubscriptionProcess";
import { SubscriptionProcessAsyncActions, SubscriptionProcessSyncActions } from "./types";

const createAsyncActions = (
  actions: SubscriptionProcessSyncActions,
  getState: () => SubscriptionProcessState
): SubscriptionProcessAsyncActions => {
  return {
    fetchSubscriptionProcess: async (riskId, devisId, borrowerProjectId, keepContent) => {
      actions.setCurrentQuoteId(devisId || null);
      actions.setCurrentBorrowerProjectId(borrowerProjectId || null);
      await fetchSubscriptionProcess(riskId, actions, getState, devisId, borrowerProjectId, keepContent);
    },

    fetchBorrowerProject: async (borrowerProjectId) => {
      // Profiling route: no quote in context. Without this reset, a stale quoteId left by a
      // contractualization page visited earlier in the session would be sent on the next
      // refresh, and the back would answer in contractualization mode (no risk data).
      actions.setCurrentQuoteId(null);
      actions.setCurrentBorrowerProjectId(borrowerProjectId || null);
      await fetchBorrowerProject(borrowerProjectId, actions);
    },

    refreshSubscriptionProcess: async () => {
      const state = getState();

      if (state.currentBorrowerProjectId) {
        await fetchSubscriptionProcess(
          state.riskId,
          actions,
          getState,
          state.currentQuoteId || undefined,
          state.currentBorrowerProjectId
        );
        return
      }

      if (state.riskId) {
        await fetchSubscriptionProcess(
          state.riskId,
          actions,
          getState,
          state.currentQuoteId || undefined,
        );
      }

    }
  }
}

export default createAsyncActions
